import { Button, Container, Form, Modal, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
// import phoneIcon from 'assets/images/login-call.svg'
import coin from 'assets/images/coin.svg'
import BaseModal from './BaseModal'
import { useRequestOTP } from 'dataLayer/user'
import { memo } from 'react'

function RewardModal({
	show,
	onHide,
	setQuantityGold,
	quantityGold,
	isLoading,
	handleAddReward,
	itemSelect,
	errorMultiples,
	user,
	...otherProps
}) {
	const { t } = useTranslation()

	function handleGoldInput(e) {
		setQuantityGold(e.target.value)
	}
	return (
		<>
			<BaseModal show={show} onHide={onHide} {...otherProps}>
				<Container fluid className="baseinput-container">
					<Modal.Header>
						<Modal.Title
							id="contained-modal-title-vcenter"
							className="login-otp-title"
						>
							{t('modal.reward.title')}
						</Modal.Title>
						<Modal.Body>
							<p
								style={{
									fontSize: 20,
									fontWeight: 600,
								}}
							>
								{`${itemSelect?.coin} Gold = ${itemSelect?.name}`}
							</p>
						</Modal.Body>
					</Modal.Header>
					<Modal.Body>
						<Form>
							<Form.Group className=" base-input">
								<img src={coin} alt="" />
								<Form.Control
									type="number"
									value={quantityGold}
									onChange={handleGoldInput}
									id="msisdn"
									placeholder={t('modal.form.gold')}
								/>
							</Form.Group>
							<p style={{ fontSize: 12 }}>
								{`${t('modal.reward.sub_input')} ${t(
									'modal.reward.require_input',
								).replace('[number]', itemSelect.coin)}`}
							</p>
							{errorMultiples ? (
								<p style={{ fontSize: 12, color: 'red' }}>{errorMultiples}</p>
							) : null}
							{user.coin > itemSelect.coin * 10 &&
								quantityGold < itemSelect.coin * 10 ? (
								<p style={{ fontSize: 12, color: 'red' }}>
									{t('modal.reward.note_input').replace(
										'[number]',
										itemSelect?.coin * 10,
									)}
								</p>
							) : null}
							{user.coin < itemSelect.coin * 10 || user.coin < quantityGold ? (
								<p style={{ fontSize: 12, color: 'red' }}>
									{t('modal.reward.check_gold_enought')}
								</p>
							) : null}
						</Form>
					</Modal.Body>
					<Modal.Footer>
						<Button
							variant="secondary"
							disabled={
								isLoading ||
								quantityGold < itemSelect.coin * 10 ||
								user.coin < itemSelect.coin * 10 ||
								user.coin < quantityGold
							}
							onClick={handleAddReward}
						>
							{t('modal.reward.confirm_button')}
							{isLoading ? (
								<Spinner animation="border" role="status"></Spinner>
							) : null}
						</Button>
					</Modal.Footer>
				</Container>
			</BaseModal>
		</>
	)
}

export default memo(RewardModal)
